import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const LiveNotice = ({ content }) => {
    const { noticeText } = content;

    return (
        <div className={styles.wrap}>
            <div className={styles.content}>
                <span className={styles.textPrefix}>直播预告：</span>
                <span>{noticeText}</span>
            </div>
        </div>
    );
};

LiveNotice.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(LiveNotice);
